export default __webpack_public_path__ + "static/media/_1035852.658440d9.webp";